var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{attrs:{"value":_vm.value,"readonly":_vm.readonly,"placeholder":_vm.placeholder,"type":"date","value-format":"yyyy/MM/dd","format":_vm.format,"disabled":_vm.disabled,"clearable":_vm.clearable},on:{"change":_vm.onChange},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }